import axios from "axios";//原生的axios
import config from '../config.json';
import {Message} from "element-ui";
import { Loading } from 'element-ui';

//用来拦截用的
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
//创建一个axios单例
const http= axios.create({
    baseURL:config.interceptor.baseURL??'',
    timeout:Number(config.interceptor.timeout)??5000,//超时时间
    // headers:{"Content-Type":"application/config;charset=utf-8"},
});

let loading;
//拦截器  -请求拦截
http.interceptors.request.use(config=>{
    /*loading = Loading.service({//加载loading
        lock: true,
        text: '正在请求数据中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });*/
    //部分接口需要token
    let token=localStorage.getItem('token');
    if(token){
        config.headers.Authorization=token;//后台需要鉴权
    }
    return config;
},err=>{
    return Promise.reject(err);
});

//拦截器  -响应拦截
http.interceptors.response.use((res)=>{
    if(loading){loading.close()}

    if(res.status&&res.status===200){//请求成功了200，失败了是404
        //此处需要判断鉴权失效
        if(res.data.code&&res.data.code===14007){//没有鉴权，或者鉴权失效
            localStorage.removeItem('token');
            Message({message:res.data.msg,type:"error"});//登录失效提示
            this.$store.commit('toPage','/home');
            return;
        }
        if (res.data.status){
            if (res.data.mailbox){
                sessionStorage.setItem('mailBox',res.data.mailbox);
            }
            if (res.data.role){
                sessionStorage.setItem('userType',res.data.role);
            }
            if (res.data.tel){
                sessionStorage.setItem('phoneNumber',res.data.tel);
            }

            if (typeof res.data.data ==="string"&&res.data.data.length>2){
                return Promise.resolve(JSON.parse(res.data.data));
            }else if(res.data.data){
                return  Promise.resolve(res.data.data);
            }else {
                return  Promise.resolve(res.data);
            }
        }else {
            return  Promise.resolve(res.data);
        }

    }else{
        return Promise.reject(res.data);
    }
},err=>{
    return Promise.reject(err);
});

//整体导出
export default http;




